import "./Home.module.css";
import Encabezado from "@/reusable_sections/Header";
import HeroPrincipal from "./sections/HeroPrincipal";
import QuienesSomosResumen from "./sections/QuienesSomosResumen";
import Servicios from "./sections/Servicios";
import Productos from "./sections/Productos";
import CasosDeExito from "./sections/CasosDeExito";
import ContactoRapido from "./sections/ContactoRapido";
import FooterSection from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Encabezado />
      <HeroPrincipal />
      <QuienesSomosResumen />
      <Servicios />
      <Productos />
      <CasosDeExito />
      <ContactoRapido />
      <FooterSection />
    </div>;
}